enum HookEnum {
  activity = 'activity',
  post = 'post',
  topics = 'topics',
  topic = 'topic',
  topics_admin = 'topics_admin',
  mevosUsers = 'mevosUsers',
}

export default HookEnum;
